import React from "react";
import markUrl from "@webcore/assets/datafabriq-mark.svg";

interface DatafabriqMarkProps {
  width?: number | string;
  height?: number | string;
  className?: string;
}

const DatafabriqMark: React.FC<DatafabriqMarkProps> = ({ width, height, className }) => (
  <img
    src={markUrl}
    alt=""
    aria-hidden="true"
    width={width}
    height={height}
    className={className}
  />
);

export default DatafabriqMark;
